import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { MarcacaoModel } from "../models/marcacao.model";


@Injectable({
  providedIn: 'root'
})
export class SharedMarcacaoService {
  private dataSource = new Subject<MarcacaoModel | undefined>();
  public marcacaoAtual = this.dataSource.asObservable();
  private evolucaoCopiedSource = new BehaviorSubject<string>('');
  public evolucaoCopiada = this.evolucaoCopiedSource.asObservable();
  private prescricaoCopiedSource = new BehaviorSubject<string>('');
  public prescricaoCopiada = this.prescricaoCopiedSource.asObservable();
private exameCopiedSource = new BehaviorSubject<string[]>([]); 
  public exameCopiado = this.exameCopiedSource.asObservable();
  private solicitacaoCopiedSource = new BehaviorSubject<string>('');
  public solicitacaoCopiada = this.solicitacaoCopiedSource.asObservable();
  

  constructor() { }

  public setMarcacaoAtual(marcacao: MarcacaoModel | undefined) {    
    this.dataSource.next(marcacao);
  }

  public setEvolucaoCopiada(evolucao: string) {
    this.evolucaoCopiedSource.next(evolucao);
  }

  public setPrescricaoCopiada(prescricao: string) {
    this.prescricaoCopiedSource.next(prescricao);
  }

  public setExameCopiado(exame: string[]) {
    this.exameCopiedSource.next(exame);
  }

  public setSolicitacaoCopiada(soliciacao: string) {
    this.solicitacaoCopiedSource.next(soliciacao);
  }
}
